import { Injectable } from '@angular/core';
import { BaseNotificationViewModel } from '@app/notification/models/base-notification-view-model';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationDispatcherService {

    onNotificationReceived = new Subject<BaseNotificationViewModel>();

    dispatch(notification: BaseNotificationViewModel): void {
    	this.onNotificationReceived.next(notification);
    }
}